import React from 'react';
import { Link } from 'react-router-dom';
import SEOHelmet from './SEOHelmet';
import Header from './Header';
import Footer from './Footer';
import MainHeader from './MainHeader';
import { FaExclamationTriangle, FaHome } from 'react-icons/fa';

const NotFound = () => {
    return (
        <>
            <SEOHelmet 
                title="404 - Page Not Found" 
                description="The page you are looking for does not exist or has been moved." 
                path="/404"
            />
            {/* Override robots for 404 to ensure it doesn't get indexed */}
            <meta name="robots" content="noindex, nofollow" />
            
            <Header />
            <MainHeader />
            
            <div style={{
                minHeight: '60vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                padding: '40px 20px',
                background: '#0c001f',
                color: 'white'
            }}>
                <FaExclamationTriangle style={{ fontSize: '6rem', color: '#a04ff4', marginBottom: '20px' }} />
                <h1 style={{ fontSize: '4rem', fontWeight: 'bold', marginBottom: '10px' }}>404</h1>
                <h2 style={{ fontSize: '2rem', marginBottom: '20px' }}>Oops! Page Not Found</h2>
                <p style={{ fontSize: '1.2rem', color: '#ccc', marginBottom: '40px', maxWidth: '600px' }}>
                    The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
                </p>
                <Link to="/" style={{
                    background: '#a04ff4',
                    color: 'white',
                    padding: '12px 30px',
                    borderRadius: '8px',
                    fontSize: '1.1rem',
                    textDecoration: 'none',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '10px',
                    fontWeight: '600',
                    transition: 'background 0.3s ease',
                    marginTop: '10px'
                }}
                onMouseOver={(e) => e.currentTarget.style.background = '#8b3dff'}
                onMouseOut={(e) => e.currentTarget.style.background = '#a04ff4'}>
                    <FaHome style={{ fontSize: '1.2rem', marginBottom: '2px' }} /> Back to Homepage
                </Link>
            </div>
            
            <Footer />
        </>
    );
};

export default NotFound;
